import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

const RMDButton = ({children, ...otherProps}) => (
  <Button 
    className={"RMDButton-Root"} {...otherProps}
  >
    {children}
  </Button>
);

RMDButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default RMDButton;